import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./sources/en-US.json";
import kh from "./sources/km-KH.json";
import cn from "./sources/zh-CN.json";

// * Get the language from local storage
const savedLanguage = localStorage.getItem("i18nextLng") || "en";

// * Initialize i18next
i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: savedLanguage,
    interpolation: { escapeValue: false },
    resources: {
      en: { translation: en },
      kh: { translation: kh },
      cn: { translation: cn },
    },
  });

// * Save the language to local storage
i18next.on("languageChanged", (lng) => {
  localStorage.setItem("i18nextLng", lng);
});

export default i18next;
